import { useState } from "react";
import { useComponentState } from "@miplatform/hooks";
import { ICalendarConfig, IInspectionAttempt } from "@miplatform/types";
import { combineCalendarFilters } from "@miplatform/utils";
import { useInspectionAttempts } from "../../hooks";

export const useInspectionListViewModel = () => {
  const { getInspections } = useInspectionAttempts();

  const stateManager = useComponentState();

  const [inspectionList, setInspectionList] = useState<IInspectionAttempt[]>(
    []
  );

  const getInspectionList = async (calendar: ICalendarConfig) => {
    return stateManager.run(async () => {
      const filters = combineCalendarFilters({
        filtersArray: [calendar?.filter ?? {}],
        templateIdFilters: calendar?.orderTemplateIds,
      });
      const inspections = await getInspections({ filters });
      setInspectionList(inspections.data);
    });
  };

  return {
    inspectionList,
    getInspectionList,
    isLoading: stateManager.isBusy(),
  };
};
